<h1 mat-dialog-title>Create Training Set</h1>
<div class="modal-wide" mat-dialog-content>
  <form class="form-full-width" [formGroup]="form">
    <div data-id="training-set-files">
      <label class="modal-body-heading">{{ payload.files ? 'File Set' : 'Query Result' }}</label>
      <p>{{ payload.file_count }} file{{ payload.file_count === 1 ? '' : 's' }} selected.</p>
    </div>
    <div class="margin-20"></div>

    <div>
      <label class="modal-body-heading">Destination Project</label>
      <mat-form-field appearance="outline">
        <mat-select
          formControlName="projectId"
          test-id="training-set-project-select"
          [attr.data-id]="'training-set-project-select'"
        >
          @for (group of groups$ | async; track group) {
            <mat-optgroup [label]="group.label">
              @for (project of group.projects; track project) {
                <mat-option [value]="project._id">
                  {{ project.label }}
                </mat-option>
              }
            </mat-optgroup>
          }
        </mat-select>
        <mat-error data-id="training-set-projects-error"> A destination project is required. </mat-error>
      </mat-form-field>
    </div>
    <div class="margin-20"></div>

    <div>
      <label class="modal-body-heading">Training Labels</label>
      <mat-form-field data-id="training-set-labels">
        <mat-autocomplete
          #labelAutocomplete="matAutocomplete"
          test-id="training-set-labels-autocomplete"
          (optionSelected)="labelValueStream$.next($event.option.value)"
        >
          @for (field of fields$ | async; track field) {
            <mat-option [value]="field.name">
              {{ field.name }}
            </mat-option>
          }
        </mat-autocomplete>
        <mat-chip-grid #labelChipList aria-label="Training labels" formControlName="labels">
          @for (chipValue of form.get('labels').value; track chipValue; let chipIndex = $index) {
            <mat-chip-row (removed)="removeChip(chipIndex)">
              {{ chipValue }}
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip-row>
          }
          <input
            #labelChipInput
            formControlName="labelInput"
            test-id="training-set-label-input"
            [matAutocomplete]="labelAutocomplete"
            [matChipInputAddOnBlur]="true"
            [matChipInputFor]="labelChipList"
            (matChipInputTokenEnd)="labelValueStream$.next($event.value)"
          />
        </mat-chip-grid>
        <mat-error data-id="training-set-labels-error"> At least one label is required. </mat-error>
      </mat-form-field>
    </div>
    <div class="margin-20"></div>

    <div>
      <label class="modal-body-heading">Training File Name</label>
      <mat-form-field appearance="outline">
        <input data-id="training-set-filename" formControlName="filename" matInput test-id="training-set-filename" />
      </mat-form-field>
      <small class="help-block">
        @if (outputFilePath$ | async; as filePath) {
          <span data-id="training-set-output">
            The training set will be saved to <strong>{{ filePath }}</strong>
          </span>
        }
      </small>
    </div>
    <div class="margin-20"></div>
  </form>
</div>
<div align="end" mat-dialog-actions>
  <button data-id="training-set-close" mat-button test-id="training-set-close" (click)="onClose()">Close</button>
  <button
    color="primary"
    data-id="training-set-create"
    mat-flat-button
    test-id="training-set-create"
    [disabled]="form.disabled || !form.valid"
    (click)="onCreate()"
  >
    Create
  </button>
</div>
